import React from "react";
import PrincipalHero from "./Principalhero";
import PrincipalAchivement from"./PrincipalAchivement";
import PrincipalGallery from"./PrincipalGallery";
import PrincipalExperince from"./PrincipalExperince";

const Principal = () => {
  return (
    <>
      <PrincipalHero />
      <PrincipalAchivement/>
      <PrincipalGallery/>
      <PrincipalExperince/>
    </>
  );
};

export default Principal;